import React from 'react';
import './StateGuidelines.css';

const StateGuidelines = ({ html = '' }) => {
  return (
    <div
      className="stateGuidelines"
      dangerouslySetInnerHTML={{ __html: html }}
    ></div>
  );
};

export default StateGuidelines;
